import { LoginForm } from "@modules/Login/widgets";
import React from "react";

const Login = (): JSX.Element => {
  return <LoginForm />;
};

export default Login;
